import { ref } from 'vue';
import ApiService from '@/core/services/api.service';
import { cloneDeep } from 'lodash';
import { makeToastFaile } from '@/utils/common';

export default function useStoreSelector() {
  const optionStores = ref([]);
  const filteredOptions = ref([]);

  const fetchStores = async () => {
    try {
      const response = await ApiService.get('/stores/getStores');
      const stores = response.data.data;

      optionStores.value = stores.map((element) => ({
        code: element.id,
        name: element.shortName,
        checked: false,
      }));

      filteredOptions.value = cloneDeep(optionStores.value);
      return optionStores.value;
    } catch (error) {
      makeToastFaile(error.message || 'Lỗi khi tải dữ liệu cửa hàng');
      return [];
    }
  };

  const fetchStoresByIds = async (listId = []) => {
    try {
      const param = { listId };
      const response = await ApiService.query('/stores/getStores', {
        params: param,
      });
      return response.data.data;
    } catch (error) {
      makeToastFaile(error.message || 'Lỗi khi tải dữ liệu cửa hàng');
      return [];
    }
  };

  const onSelectStore = (option) => {
    const index = optionStores.value.findIndex(
      (item) => item.name === option.name,
    );
    if (index !== -1) {
      optionStores.value[index].checked = true;
      filteredOptions.value = cloneDeep(optionStores.value);
    }
  };

  const onRemoveStore = (option) => {
    const index = optionStores.value.findIndex(
      (item) => item.name === option.name,
    );
    if (index !== -1) {
      optionStores.value[index].checked = false;
      filteredOptions.value = cloneDeep(optionStores.value);
    }
  };

  return {
    optionStores,
    filteredOptions,
    fetchStores,
    fetchStoresByIds,
    onSelectStore,
    onRemoveStore,
  };
}
